import type { Question, QuotaGroup } from '@api/surveys/utilities/types';

export const getDropdownOptions = (items: Item[]) => {
  return items.map((item) => {
    const isQuotaGroup = 'name' in item;
    return {
      label: isQuotaGroup ? item.name : item.text,
      value: item.id,
    };
  });
};

/**
 * Constructs the survey preview URL and injects the preview session ID when one exists.
 */
export const buildPreviewUrl = (previewSessionId: string | null) => {
  const previewEndpoint = import.meta.env.VITE_SURVEY_PREVIEW_ENDPOINT;
  if (!previewEndpoint) return '';

  const previewEndpointUrl = new URL(previewEndpoint);
  if (previewSessionId) {
    previewEndpointUrl.searchParams.set('preview_session_id', previewSessionId);
  }
  return previewEndpointUrl.toString();
};

export const getIsPreviewDisabled = (questions?: Question[]) => !questions?.length;

export type Item = Question | QuotaGroup;

export interface PreviewSelection {
  quotaGroupId?: number;
  questionId?: number;
}
